import { SearchRequest } from "./types/request"

export class Search {
    private _term: string | null
    private _idSearchEnabled: boolean | null
    private _characteristicIds: string[]
    private _characteristicViewIds: string[]

    constructor() {
        this._term = null
        this._idSearchEnabled = null
        this._characteristicIds = []
        this._characteristicViewIds = []
    }

    /**
     * The term to search for. When no other options are specified, the full text search is performed on the product IDs and on all characteristics by default.
     * @param {String} txt The term to search for
     * @returns this
     */
    term(txt: string): this {
        this._term = txt
        return this
    }

    /**
     * Whether the full text search should be applied to the product IDs.
     * When this value is set to false, either characteristicIds or characteristicViewIds must be defined, otherwise service
     * responds with status code 400 (Bad Request).
     * @param {Boolean} enabled
     * @returns this
     */
    idSearch(enabled: boolean): this {
        this._idSearchEnabled = enabled
        return this
    }

    /**
     * The IDs of the characteristics to which the full text search should be applied.
     * @param {String|Array} id the id or ids
     * @return this
     */
    characteristic(id: string | string[]): this {
        if (Array.isArray(id)) {
            this._characteristicIds = this._characteristicIds.concat(id)
        } else {
            this._characteristicIds.push(id)
        }

        return this
    }

    /**
     * The IDs of the characteristic views to which the full text search should be applied.
     * @param {String|Array} view the view or views
     * @return this
     */
    characteristicView(view: string | string[]): this {
        if (Array.isArray(view)) {
            this._characteristicViewIds =
                this._characteristicViewIds.concat(view)
        } else {
            this._characteristicViewIds.push(view)
        }

        return this
    }

    build(): SearchRequest | null {
        if (this._term === null) {
            return null
        }

        const result = {} as SearchRequest
        if (this._term !== null) {
            result.term = this._term
        }

        if (this._idSearchEnabled !== null) {
            result.idSearchEnabled = this._idSearchEnabled
        }

        if (this._characteristicIds.length > 0) {
            result.characteristicIds = this._characteristicIds
        }

        if (this._characteristicViewIds.length > 0) {
            result.characteristicViewIds = this._characteristicViewIds
        }

        return result
    }
}
